import $ from "jquery";
import { _ } from "extensions/underscore";
import { Backbone } from "extensions/backbone";
import moment from "moment";

export const Draggah = function(opts) {
    this.cid = _.uniqueId("drgh");
    
    const resizers = {
        east: null,
        west: null
    };
    let dragging = false;
    let resizingEast = false;
    let resizingWest = false;
    
    let group;
    let label;
    let rectangle;
    
    const self = this;
    
    opts = {
        css: {
            fill: "#333",
            "fill-opacity": "0.1",
            stroke: "#333",
            "stroke-width": "1px",
            "stroke-opacity": "0.4",
            "shape-rendering": "crispedges",
            "stroke-dasharray": "3 3",
            cursor: "move"
        },
        resizer: {
            width: 6,
            css: {
                cursor: "ew-resize",
                opacity: 0,
                fill: "#333",
                "fill-opacity": "0.1"
            }
        },
        ...opts
    };
    
    const triggerEvent = (event) => {
        if (event === "deselect" && !rectangle) return;
        
        this.trigger(event, rectangle ? {
            start: moment.utc(rectangle.params.min).toISOString(),
            end: moment.utc(rectangle.params.max).toISOString()
        } : {});
    };
    
    /**
     * Get start and end points of selected markers
     * @param min_max array of min and max coords selection
     * @param {Axis} axis Highcharts x-axis
     * @param {boolean} points whether on not the points already converted from pixels
     * @returns {Array} Min and max in UTC time
     */
    const coordsToValue = function(min_max, axis, points, chart) {
        const min = points ? min_max[0] : Number.parseInt(axis.toValue(min_max[0]), 10);
        const max = points ? min_max[1] : Number.parseInt(axis.toValue(min_max[1]), 10);
        
        let allChartPoints = chart.series.reduce((acc, cur) => {
            cur.data.forEach((point) => {
                acc[point.x] = true;
            });
            return acc;
        }, {}); // Use {} as an accumulator to also remove duplicates
        
        // Convert to Numbers
        allChartPoints = Object.keys(allChartPoints).map((key) => Number.parseInt(key, 10));
        
        const ticks = allChartPoints.filter((tick) => tick >= min && tick <= max);
        
        if (ticks.length === 0) {
            return false;
        }
        
        return [_.first(ticks) || [], _.last(ticks) || []];
    };
    
    const makeRectangle = function(attrs) {
        // Return rectangle if it has been already drawn
        if (rectangle) {
            return rectangle;
        }
        
        // Numbers along x axis
        let currentX = 0;
        const axisLeftX = self.chart.xAxis[0].pos;
        const axisRightX = self.chart.xAxis[0].pos + self.chart.xAxis[0].width;
        
        // SVG elements
        group = self.chart.renderer.g().add();
        
        const rect = self.chart.renderer.rect(0, 0, 0, 0, 0).attr(attrs).css(opts.css).add(group);
        
        const resizerEast = self.chart.renderer.rect(0, 0, 0, 0, 0).attr({
            x: attrs.x + attrs.width - (opts.resizer.width / 2),
            y: attrs.y,
            width: opts.resizer.width,
            height: attrs.height
        }).css(opts.resizer.css).add(group).toFront();
        
        const resizerWest = self.chart.renderer.rect(0, 0, 0, 0, 0).attr({
            x: attrs.x - opts.resizer.width / 2,
            y: attrs.y,
            width: opts.resizer.width,
            height: attrs.height
        }).css(opts.resizer.css).add(group).toFront();
        
        // Make sure that the rectangle above other element. Well... trust Highcharts to do that :)
        group.toFront();
        
        self.chart.original_onContainerMouseDown = self.chart.pointer.onContainerMouseDown;
        self.chart.pointer.onContainerMouseDown = function(...args) {
            if (dragging || resizingEast || resizingWest) {
                return false;
            }
            return self.chart.original_onContainerMouseDown.call(this, ...args);
        };
        
        // If mousedown occured on rectangle then bring it to dragging state
        rect.on("mousedown", (e) => {
            currentX = e.clientX;
            dragging = true;
        });
        
        resizerEast.on("mousedown", (e) => {
            currentX = e.clientX;
            resizingEast = true;
        });
        
        resizerWest.on("mousedown", (e) => {
            currentX = e.clientX;
            resizingWest = true;
        });
        
        $(self.chart.container).on("mousedown.dateZoomer", function(e) {
            // If the rectangle is rendered
            // eslint-disable-next-line eqeqeq
            if (rectangle.params != null) {
                const { x, width } = rectangle.params;
                const dx = x + e.clientX - currentX;
                
                // Mousedown is out of current bounds
                const resizerArea = opts.resizer.width / 2;
                if (dx < x - resizerArea || dx > x + width + resizerArea) {
                    triggerEvent("deselect");
                    
                    self.cleanUp();
                    e.stopPropagation();
                    
                    // Quick way to avoid going to selection mode again
                    $(this).trigger("mouseup");
                }
            }
        }).on("mousemove.dateZoomer", (e) => {
            const isInteracting = dragging || resizingWest || resizingEast;
            
            let rectX;
            let eastX;
            let westX;
            let width;
            let dx;
            
            // Logic that is common for all interacting actions
            if (isInteracting) {
                rectX = Number.parseInt(rectangle.element.getAttribute("x"), 10);
                eastX = Number.parseInt(resizerEast.element.getAttribute("x"), 10);
                westX = Number.parseInt(resizerWest.element.getAttribute("x"), 10);
                width = Number.parseInt(rectangle.element.getAttribute("width"), 10);
                dx = rectX + e.clientX - currentX;
                
                // Return earlier if hit left or right boundary or width is less than min
                if (dx < axisLeftX || dx + width > axisRightX) {
                    return false;
                }
            }
            
            // Now action-specific stuff
            if (dragging) {
                rectangle.element.setAttribute("x", dx);
                resizerEast.element.setAttribute("x", eastX + e.clientX - currentX);
                resizerWest.element.setAttribute("x", westX + e.clientX - currentX);
            } else if (resizingEast) {
                rectangle.element.setAttribute("width", width + e.clientX - currentX);
                resizerEast.element.setAttribute("x", eastX + e.clientX - currentX);
            } else if (resizingWest) {
                rectangle.element.setAttribute("x", dx);
                rectangle.element.setAttribute("width", width + currentX - e.clientX);
                resizerWest.element.setAttribute("x", westX + e.clientX - currentX);
            }
            
            // And finalizing the event with setting values to an object and updating label. Again, this is common to all interactions
            if (isInteracting) {
                currentX = e.clientX;
                
                // Translate x to points
                const minMax = coordsToValue([dx, dx + width], self.chart.xAxis[0], false, self.chart);
                
                // Store drag params in rectangle
                rectangle.params = {
                    x: rectX,
                    width,
                    min: minMax[0],
                    max: minMax[1]
                };
            }
        }).on("mouseup.dateZoomer", () => {
            dragging = false;
            resizingWest = false;
            resizingEast = false;
            triggerEvent("dragEnd");
        });
        
        rectangle = rect;
        resizers.east = resizerEast;
        resizers.west = resizerWest;
    };
    
    /**
     * API
     */
    
    /**
     * Create draggah container based on provided options
     * @param {object} createOpts options hash to create the draggah
     */
    this.create = function(createOpts) {
        if (!this.chart) {
            throw new Error("Chart instance is required");
        }
        
        const yAxis = this.chart.yAxis[0];
        const xAxis = this.chart.xAxis[0];
        
        const { min: yMinPoint, max: yMaxPoint } = yAxis;
        
        // Translate points to pixels
        const xMin = xAxis.translate(createOpts.xMinPoint);
        const xMax = xAxis.translate(createOpts.xMaxPoint);
        const yMin = yAxis.translate(yMinPoint);
        const yMax = yAxis.translate(yMaxPoint);
        
        // Create rectangle and store in closure
        makeRectangle({
            x: xMin + this.chart.plotLeft,
            y: this.chart.plotHeight + this.chart.plotTop - yMax,
            width: xMax - xMin,
            height: yMax - yMin
        });
        
        const minMax = coordsToValue([createOpts.xMinPoint, createOpts.xMaxPoint], xAxis, true, this.chart);
        
        // Don't allow selection that doesn't include any markers
        if (minMax === false) {
            return self.cleanUp();
        }
        
        // Store drag params in rectangle
        rectangle.params = {
            x: Number.parseInt(xMin + this.chart.plotLeft, 10),
            width: Number.parseInt(this.chart.plotHeight + this.chart.plotTop - yMax, 10),
            min: minMax[0],
            max: minMax[1]
        };
        
        // Destroy it on window resize
        $(window).on(`resize.dateZoomer.${this.cid}`, this.reflow.bind(this));
        
        triggerEvent("selectionEnd");
        
        // ShowLabel(this, minMax[0], minMax[1]);
    };
    
    /**
     * Reflow the draggah due to some event, e.g. window has been resized
     */
    this.reflow = function() {
        const params = rectangle.params;
        
        // Trigger event to deselect existing draggah
        triggerEvent("deselect");
        
        // Remove current draggah
        this.cleanUp();
        
        let halfRange;
        if (this.chart.range === "day") {
            halfRange = 4.32e+7; // In ms
        }
        
        // Create another one with delay of 1 second to allow Highcharts reflow the main chart
        window.setTimeout(this.create.bind(this, {
            xMinPoint: params.min - halfRange,
            xMaxPoint: params.max + halfRange
        }), 1000);
    };
    
    /**
     * Selection event that drives initial rendering
     * NOTE: `this` is a chart instance in this function
     * @param {jQuery Event} event Jquery event with highcharts steroids
     */
    this.onSelection = function(event) {
        // Prevent zoom in
        event.preventDefault();
        
        // Get selection extremes. Both Y-values are not really important here and not even included in event.
        const { min: xMinPoint, max: xMaxPoint } = event.xAxis[0];
        
        // Create the draggah with selected options
        self.create({
            xMinPoint,
            xMaxPoint
        });
    };
    
    /**
     * Clean up SVG elements created by Draggah
     * Clean up events
     */
    this.cleanUp = function() {
        $(window).off(`resize.dateZoomer.${this.cid}`);
        
        if (self.chart && self.chart.container && self.chart.pointer) {
            // Unbind dragger events to realease handlers and their references to GC
            $(self.chart.container).off("mouseup.dateZoomer mousemove.dateZoomer mousedown.dateZoomer");
            
            // Set back original CMD event
            self.chart.pointer.onContainerMouseDown = self.chart.original_onContainerMouseDown;
        }
        
        // Remove rectangle
        if (rectangle) {
            rectangle.destroy();
            
            // Unset rectangle
            rectangle = void 0;
        }
        
        if (label) {
            label.destroy();
            
            // Unset label
            label = void 0;
        }
        
        // Destroy resizers
        [resizers.east, resizers.west].forEach((resizer) => {
            if (resizer) {
                resizer.destroy();
            }
        });
        resizers.east = null;
        resizers.west = null;
        
        // Finally destroy SVG group
        if (group) {
            group.destroy();
            group = null;
        }
    };
    
    // DESTRUCTOR
    this.destroy = function() {
        // Trigger event to deselect existing draggah
        triggerEvent("deselect");
        
        // Invalidate all events handlers
        this.stopListening();
        this.cleanUp();
        this.chart = void 0;
    };
    
    this.isActive = function() {
        return rectangle !== void 0;
    };
    
    Object.assign(this, Backbone.Events);
};
